module.exports = __webpack_public_path__ + "static/img/img_member_d.b65a016f.png";